import React,{useState}from 'react'
import Contact from './Contact'
import Profile from './Profile'
import Projects from './Projects'
import Qualification from './Qualification'
import Sidebaar from './Sidebaar'

function Body(props) {
  const [mode,setMode]= useState('dark')

  const togleMode=()=>{
    if (mode === 'light'){
      setMode('dark')
      
    }
    else{
      setMode('light')
      document.body.style.backgroundColor = 'white'
    }
  }

  return (
    <div>
    <div id='main'>
      <Sidebaar mode={mode} togleMode={togleMode}/>

      <div id='sideBar2'>

        <Profile mode={mode} togleMode={togleMode}/>
        <Qualification mode={mode} togleMode={togleMode}/>
        <Projects mode={mode} togleMode={togleMode}/>
        <Contact mode={mode} togleMode={togleMode}/>

      </div>

    </div>
    </div>
  )
}

export default Body